import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { QuoteApproverResponse } from '../models/quote-approver.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface QuoteApproverDrawerOptions {
  approverId?: number;
}

@Injectable({ providedIn: 'root' })
export class QuoteApproverDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: QuoteApproverDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<QuoteApproverResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: QuoteApproverDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: QuoteApproverResponse): void {
    this.saved$$.next(item);
  }
}
